<template>
    <div>
        <button v-on:click="$emit('forward', -120)" class="oma-forward-button oma-controls-button fa-undo" :disabled="!showPast" title="Reculer de 2 minutes" ><span>2'</span></button>
        <button v-on:click="$emit('forward', -20)" class="oma-forward-button oma-controls-button fa-undo" :disabled="!showPast" title="Reculer de 20 secondes" ><span>20</span></button>
        <button v-on:click="$emit('playpause')" class="oma-controls-button fa-play" v-if="paused" ></button>
        <button v-on:click="$emit('playpause')" class="oma-controls-button fa-pause" v-else></button>
        <button v-on:click="$emit('forward', 20)" class="oma-forward-button oma-controls-button fa-repeat" :disabled="!showFuture" title="Avancer de 20 secondes" ><span>20</span></button>
        <button v-on:click="$emit('forward', 120)" class="oma-forward-button oma-controls-button fa-repeat" :disabled="!showFuture" title="Avancer de 2 minutes" ><span>2'</span></button>
    </div>
</template>

<script>
export default {
    props: {
        oma: {type: Object, required: true},
        paused : {type: Boolean, required: true},
        showPast: {type: Boolean, required: false, default: false},
        showFuture: {type: Boolean, required: false, default: false},
    },
    data: () => { return {
    }},
    methods: {
    },
}
</script>

<style scoped>
.oma-controls-button {
    cursor: pointer;
    font-size: 2.5em;
    background-color: transparent;
    border: 0;
    color: inherit;
    padding: 0;
    height: 40px;
    width: 40px;
    background-repeat: no-repeat;
    background-size: cover;
}

.oma-controls-button:disabled {
    opacity: 0;
}

.oma-forward-button span {
    position: absolute;
    top:0;
    left:0;
    font-size: 0.3em;
    margin: 40% 32%;
    font-weight: bold;
    font-family: sans-serif;
}
.oma-forward-button.fa-repeat span{
    transform: scale(-1, 1);
}

.fa-play {
    background-image: url("@/assets/img/play.svg");
}
.fa-pause {
    background-image: url("@/assets/img/pause.svg");
}
.oma-forward-button {
    position: relative;
}
.oma-forward-button.fa-undo {
    background-image: url("@/assets/img/undo.svg");
}
.oma-forward-button.fa-repeat {
    background-image: url("@/assets/img/undo.svg");
    transform: scale(-1, 1);
}
@media only screen and (max-device-width: 600px) {
    .oma-forward-button span {
        font-size: 25px;
    }
    .oma-controls-button {
		height: 80px;
		width: 80px;
    }
}
</style>
